import { render, staticRenderFns } from "./PropertyAddForm.vue?vue&type=template&id=045c0fa8"
import script from "./PropertyAddForm.vue?vue&type=script&lang=ts"
export * from "./PropertyAddForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports